"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CHAT_REPORT_REASON;
(function (CHAT_REPORT_REASON) {
    CHAT_REPORT_REASON["chatReportReasonSpam"] = "chatReportReasonSpam";
    CHAT_REPORT_REASON["chatReportReasonViolence"] = "chatReportReasonViolence";
    CHAT_REPORT_REASON["chatReportReasonPornography"] = "chatReportReasonPornography";
    CHAT_REPORT_REASON["chatReportReasonChildAbuse"] = "chatReportReasonChildAbuse";
    CHAT_REPORT_REASON["chatReportReasonCopyright"] = "chatReportReasonCopyright";
    CHAT_REPORT_REASON["chatReportReasonCustom"] = "chatReportReasonCustom";
})(CHAT_REPORT_REASON = exports.CHAT_REPORT_REASON || (exports.CHAT_REPORT_REASON = {}));
